import React, { useContext } from "react";
import { addPOFile } from "api/PurchaseOrder";
import { CheckMarkIcon, PlusIcon } from "components/svg";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "components/ui/Modal";
import FileInput from "components/forms/FileInput";
import BasicButton from "components/forms/BasicButton";
import { useToast } from "components/toast";
import { trackActivity } from "api/ActivityTracker";
import UserContext from "context/User";


export default function FileUpload({
  title,
  afterUpload,
  po,
  project
}: {
  title: string;
  po?: any;
  project?: any;
  afterUpload?: () => void;
}) {
  const toast = useToast();
  const { user } = useContext<any>(UserContext);

  const [value, setValue] = React.useState<any>(null);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  async function _onSubmit() {
    if (value) {
      setIsSubmitting(true);

      await fetch(value.url, {
        method: "PUT",
        headers: { "Content-Type": value?.file?.type },
        body: value?.file,
      })
        .then(async (res: any) => {
          if (res.ok) {
            
            const payload = {
              url: value?.location,
              name: value?.file?.name,
              project: {id: project?.id }
            };


            const res = await addPOFile({
              id: po.id,
              data: payload,
            });
            
            if (res?.id) {
              toast.add("File uploaded", "var(--theme-ui-colors-success)");
              setIsOpen(false);
              if (typeof afterUpload === "function") afterUpload();
              void trackActivity({
                module: "purchase_orders",
                action: "upload_purchase_order_file",
                actionType: "create",
                userId: user?.id || null,
                companyId: user?.company?.id || null,
                entityType: "purchase_order_file",
                entityId: res.id,
                metadata: {
                  fileId: res.id,
                  fileName: res?.name || value?.file?.name || null,
                },
                userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
              });
            } else {
              toast.add(
                res?.message ? res.message : "Error uploading file",
                "var(--theme-ui-colors-danger)"
              );
            }
          }
        })
        .catch((err) => {
          toast.add("Error uploading file", "var(--theme-ui-colors-danger)");
        });
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <BasicButton scheme="secondaryOutline" onClick={() => setIsOpen(!isOpen)}>
        <PlusIcon fill={"#000"} />
        {title}
      </BasicButton>
      <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} centered closeOnBackdropClick={false}>
        <ModalHeader toggle={() => setIsOpen(false)}></ModalHeader>
        <ModalBody>
          <FileInput
            directory={`purchase_orders/${po.id}/files`}
            onChange={(val: any) => {
              setValue(val[0]);
            }}
            refreshValue={isSubmitting}
            multiple={false}
          />
        </ModalBody>
        <ModalFooter>
          <BasicButton
            type="button"
            onClick={() => setIsOpen(false)}
            scheme="secondaryOutline"
          >
            Cancel
          </BasicButton>
          <BasicButton
            type="submit"
            onClick={_onSubmit}
            $submitting={isSubmitting}
            $iconHeight="14px"
            $iconWidth="14px"
            $loadingColor="#fff"
            keepText={true}
          >
            {!isSubmitting && <CheckMarkIcon fill={"#fff"} />}Add File
          </BasicButton>
        </ModalFooter>
      </Modal>
    </>
  );
}
